import { largeCurrencyFormat } from 'common/formats/formats';
import { HandleTotalValueCellsParams } from './types';

const handleTotalValueCells = (params: HandleTotalValueCellsParams) => {
  const { cell, isDisabled, isFundInvestment } = params;

  Object.assign(cell, {
    format: largeCurrencyFormat,
    gridType: 'number',
    hidden: isFundInvestment && !isDisabled,
  });
};

export default handleTotalValueCells;
